<template>
  <button 
    class="c-button c-button--brand c-button--text-center" 
    type="button"
    v-on:click="emitClick">
    <slot></slot>
  </button>
</template>

<script>
export default {
  methods: {
    emitClick(e) {
      this.$emit('click', e);
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/components/consumer/report-a-problem/_vue/BaseButton.vue